import {
  DASHBOARD_BACKGROUND_PREF_KEY,
  type DashboardBackground,
  parseDashboardBackground,
} from "@/lib/dashboard-home/background";
import {
  DASHBOARD_SHORTCUTS_PREF_KEY,
  parseStoredShortcuts,
  type StoredShortcut,
} from "@/lib/dashboard-home/shortcuts";
import {
  persistBoPreference,
  readBoPreference,
} from "@/lib/user-preferences/store";
import { useState } from "react";

const SHOW_COUNTS_PREF_KEY = "dashboard.showCounts";

/**
 * Réglages de l'accueil propres à l'utilisateur (UserConfig, préférences BO).
 * Lus à la création : la route attend l'hydratation des préférences
 * (`PrivateRouteWithInstance`). Chaque modification est enregistrée aussitôt.
 */
export function useHomePreferences() {
  const [background, setBackground] = useState<DashboardBackground>(() =>
    parseDashboardBackground(readBoPreference(DASHBOARD_BACKGROUND_PREF_KEY)),
  );
  const [shortcuts, setShortcuts] = useState<StoredShortcut[]>(() =>
    parseStoredShortcuts(readBoPreference(DASHBOARD_SHORTCUTS_PREF_KEY)),
  );
  const [showCounts, setShowCounts] = useState(
    () => readBoPreference<boolean>(SHOW_COUNTS_PREF_KEY) !== false,
  );

  const persist =
    <T>(key: string, set: (value: T) => void) =>
    (value: T) => {
      set(value);
      persistBoPreference(key, value);
    };

  return {
    background,
    saveBackground: persist(DASHBOARD_BACKGROUND_PREF_KEY, setBackground),
    shortcuts,
    saveShortcuts: persist(DASHBOARD_SHORTCUTS_PREF_KEY, setShortcuts),
    showCounts,
    saveShowCounts: persist(SHOW_COUNTS_PREF_KEY, setShowCounts),
  };
}
